import { render, staticRenderFns } from "./PlaceInput.vue?vue&type=template&id=3b8c969d"
import script from "./PlaceInput.vue?vue&type=script&lang=js"
export * from "./PlaceInput.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports